
  import { css } from 'lit';
  export const styles = css`:host{--color: var(--ig-divider-color, var(--ig-gray-300));--inset: var(--ig-divider-inset, 0);--ig-theme-variant: light}`;
  